import { render, staticRenderFns } from "./dragWidget.vue?vue&type=template&id=6eaf484a&scoped=true&"
import script from "./dragWidget.vue?vue&type=script&lang=ts&"
export * from "./dragWidget.vue?vue&type=script&lang=ts&"
import style0 from "./dragWidget.vue?vue&type=style&index=0&id=6eaf484a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaf484a",
  null
  
)

export default component.exports